import type { IResource } from '@experiences/interfaces';

import { get } from '../utility/Requests';
import { getIdentityBaseRoute } from './IdentityServiceUtils';

export const externalApiResourceUrl = `/api/identity/ExternalApiResource`;

const externalApiResourcePath = '/api/ExternalApiResource';

export function getExternalApiResources(partitionGlobalId: string, isHostMode: boolean = false) {
    const base = getIdentityBaseRoute(partitionGlobalId, isHostMode);
    const directUrl = base.endsWith(externalApiResourcePath) ? base : `${base}${externalApiResourcePath}`;
    return get<IResource[]>(directUrl, { ignoreBasePath: true });
}
